import { Booking } from '@/types';

/**
 * Resource fields for moving a booking to another resource.
 *
 * A booking carries both a primary `resourceId` and a `resourceIds` list, and
 * consumers read either one — the timeline matches a row's bookings on the
 * primary id OR membership of `resourceIds`, so a move that only rewrites
 * `resourceId` leaves the booking counted against its previous resource in
 * utilisation totals and tooltips.
 */
export function reassignedResourceFields(
  booking: Booking | undefined,
  newResourceId: string,
): Pick<Booking, 'resourceId' | 'resourceIds'> {
  const targetId = String(newResourceId);
  const previousId = booking ? String(booking.resourceId) : undefined;
  const existing = booking?.resourceIds;

  const resourceIds =
    existing && existing.length > 0
      ? existing.map((rid) => (String(rid) === previousId ? targetId : String(rid)))
      : [targetId];

  return { resourceId: targetId, resourceIds };
}
